import axios from 'axios'
import Cookies from 'js-cookie'

import { PublicRoutes } from '../../api/publicRoutes'

import * as types from '../mutation-types'
import { broadcastLogout } from '~/helpers/authWatcher'

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
}

// getters
export const getters = {
  user: (state) => state.user,
  token: (state) => state.token,
  check: (state) => state.user !== null,
}

// mutations
export const mutations = {
  [types.SAVE_TOKEN](state, { token, remember }) {
    state.token = token
  },

  [types.FETCH_USER_SUCCESS](state, { user }) {
    state.user = user
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null
    // Cookies.remove('token', { domain: config.cookie_domain, path: '/' })
    // if (config.cookie_domain == 'staging.zendrop.com') {
    //   Cookies.remove('token', { domain: 'zendrop.com', path: '/' })
    // }
  },

  [types.LOGOUT](state) {
    state.user = null
    state.token = null

    Cookies.remove('token', { domain: config.cookie_domain, path: '/' })
    if (config.cookie_domain == 'staging.zendrop.com') {
      Cookies.remove('token', { domain: 'zendrop.com', path: '/' })
    }
  },

  [types.UPDATE_USER](state, { user }) {
    state.user = user
  },
}

// actions
export const actions = {
  saveToken({ commit, dispatch }, payload) {
    commit(types.SAVE_TOKEN, payload)
  },

  async fetchUser({ commit }) {
    try {
      const { data } = await axios.get(PublicRoutes.user)

      commit(types.FETCH_USER_SUCCESS, { user: data })
    } catch (e) {
      commit(types.FETCH_USER_FAILURE)
    }
  },

  updateUser({ commit }, payload) {
    commit(types.UPDATE_USER, payload)
  },

  async logout({ commit }) {
    try {
      await axios.post(PublicRoutes.logout)
    } catch (e) {}

    commit(types.LOGOUT)
    broadcastLogout()
  },

  async fetchOauthUrl(ctx, { provider }) {
    const { data } = await axios.post(`${PublicRoutes.oauth}/${provider}`)

    return data.url
  },
}
